import { types } from 'mobx-state-tree';

export default types
  .model({
    offset: types.maybeNull(types.string),
    bottomOffset: types.maybeNull(types.string),
  })
  .actions(self => ({
    setConstraintProps(constraints) {
      self.offset = constraints.offset;
      self.bottomOffset = constraints.bottomOffset;
    },
  }));
